import { hasCreditIQ } from "./creditIQ";
import { ApplicationStore } from "src/store";
import { hasDealerOfferByVin, isDealerOfferSourceInstantApproval } from "src/store/selectors/dealerOffer";

export const getDealUUID = (state: ApplicationStore) => state.deal?.uuid;

export const isCurrentDealDealerOffer = (state: ApplicationStore) =>
    hasDealerOfferByVin(state, state.currentDeal.vin!) &&
    !isDealerOfferSourceInstantApproval(state, state.currentDeal.vin!);

export const hasCIQApplicationOrDecisioning = (state: ApplicationStore) => hasCreditIQ(state, state.currentDeal.vin!);

export const getContinueDealVIN = (state: ApplicationStore) => state.currentDeal.vin!;
